import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

export interface SsoEndpoints {
  id: number;
  idpProvider: string;
  baseUrl: string;
  clientId: string;
  env: 'PRD' | 'DEV' | 'STG';
  entityId?: number;
}

@Injectable({ providedIn: 'root' })
export class SsoEndpointsService {
  private _ssoEndpointsData$ = new BehaviorSubject<SsoEndpoints[]>(null);
  user: any;
  private selectedSsoEndpointData = new BehaviorSubject<SsoEndpoints>(null);

  private ssoRequestingUser = new BehaviorSubject<string>(null);

  public readonly ssoEndpointsData$ = this._ssoEndpointsData$.asObservable();
  public readonly selectedSsoEndpointDate$ = this.selectedSsoEndpointData.asObservable();
  public readonly ssoRequestingUser$ = this.ssoRequestingUser.asObservable();

  constructor(private http: HttpClient, private toast: ToastService) {}

  getSsoEndpoints = () => {
    return this.http.get(`${environment.expressUrl}/global/sso-endpoints`,
      { headers: { 'Content-Type': 'application/vnd.api+json' } }).subscribe({
      next: (response: { statusCode: number, data: SsoEndpoints[] }) => {
        if (response.statusCode !== 1000) {
          console.error('Error fetching SSO endpoints:', response);
          return;
        }

        this._ssoEndpointsData$.next(response.data);
      },
      error: (error) => {
        console.error('error', error);
      },
    });
  }

  setSsoRequestingUser = (ssoRequestingUserEmail: string) => {
    this.removeSsoRequestingUser();

    const form_idp_id = ssoRequestingUserEmail.split('@')[1].toLowerCase();
    const ssoEndpoints = this._ssoEndpointsData$.getValue();
    const selectedSsoEndpoint = ssoEndpoints.find((ssoEndpoint) => {
      return ssoEndpoint.idpProvider.toLowerCase() === form_idp_id;
    });

    if (selectedSsoEndpoint) {
      this.ssoRequestingUser.next(ssoRequestingUserEmail);
      this.selectedSsoEndpointData.next(selectedSsoEndpoint);
      localStorage.setItem('ssoRequestingUser', ssoRequestingUserEmail);
      localStorage.setItem('ssoSelectedEndpoint', JSON.stringify(selectedSsoEndpoint));

      return selectedSsoEndpoint;
    }

    this.toast.setToast({
      type: 'error',
      text: `No matching SSO client found for the given email: '${ssoRequestingUserEmail}'.`,
      dismissible: false,
    })
    throw new Error(`No matching SSO client found for the given email: '${ssoRequestingUserEmail}'.`);
  }

  getSsoRequestingInfo = () => {
    const ssoRequestingLocalUser = localStorage.getItem('ssoRequestingUser');
    const ssoSelectedLocalEndpoint = JSON.parse(localStorage.getItem('ssoSelectedEndpoint'));
    const ssoRequestingUser = this.ssoRequestingUser.getValue() || ssoRequestingLocalUser;
    const ssoSelectedEndpoint = this.selectedSsoEndpointData.getValue() || ssoSelectedLocalEndpoint;

    return { ssoRequestingUser, ssoSelectedEndpoint };
  }

  removeSsoRequestingUser = () => {
    localStorage.removeItem('ssoRequestingUser');
    this.ssoRequestingUser.next(null);
    localStorage.removeItem('ssoSelectedEndpoint');
    this.selectedSsoEndpointData.next(null);
  }
}
